import * as React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';
import icon_checked from '../../../assets/icons/icon_checked_large.svg';
import icon_unchecked from '../../../assets/icons/icon_unchecked_large.svg';

export const SectionSelectorField = ({ name, onChange, input, label, disabled }) => {
  const onSectionChange = (e, value) => {
    onChange(e.target.name, value);
  };
  let classes = ['access-container__panel-control-section-field'];
  return (
    <div className={[...classes].join(' ')}>
      <Checkbox
        className={'access-container__panel-control-checkbox'}
        checked={input}
        checkedIcon={<img src={icon_checked} />}
        disableRipple
        disabled={disabled}
        icon={<img src={icon_unchecked} />}
        name={name}
        color='primary'
        onChange={onSectionChange}
      />{label
        ? <div style={{ marginBottom: '0' }} className='form-field-label-row'>
          <label style={{marginRight: '0.5rem'}}>{label}</label>
        </div> : null
      }
    </div>
  );
};

SectionSelectorField.propTypes = {
  name: PropTypes.string,
  input: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
